// based on rc-trigger 2.6.5
import Trigger from './Trigger';
export default Trigger;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-trigger/index.js
// module id = 62
// module chunks = 0